//Data imports
import AccessMatrix from '@/router/access-matrix';
import LicenseKeys from "@/helpers/Constants/LicenseKeys";

//View and component imports
import Title_Job from "@/components/SingleUse/ComponentOverrides/pagetitle/Title_Job.vue";
import SubMenuTab_OrderDependent from "@/components/SingleUse/ComponentOverrides/submenu/SubMenuTab_OrderDependent.vue";
const ViewJob = () => import('@/views/job/viewjob/ViewJobContainer.vue')
const ViewJobGeneral = () => import('@/views/job/viewjob/ViewJobGeneral.vue')
const ViewCheckLists = () => import('@/views/job/viewjob/ViewJobCheckLists.vue')
const ViewJobPlanning = () => import('@/views/job/viewjob/ViewJobPlanning.vue')
const ViewJobLogg = () => import('@/views/job/viewjob/ViewJobLogg.vue')
const ViewJobResources = () => import('@/views/job/viewjob/ViewJobResources.vue')
const ReportViewer = () => import('@/components/ReportViewer.vue')

const ViewJobOrder = () => import('@/views/job/viewjob/parts/ViewJobParts.vue')
const ViewJobInvoice = () => import('@/views/job/viewjob/invoice/ViewJobInvoice.vue')
const OrderDetailForm = () => import('@/views/job/viewjob/parts/OrderDetailForm.vue')
const CreateOrderDetailMenu = () => import('@/views/job/viewjob/parts/CreateOrderDetailMenu.vue')

//Export item
const branch = {
  meta: {
    authorize: AccessMatrix.JobsTrunk.viewjob_branch,
    icon: "$job",
    contextMenu: true,
    overrides: {
      sidebar: false,
      title: Title_Job,
    },
  },
  path: "view/:jobId",
  name: "ViewJob",
  redirect: { name: 'ViewJobGeneral' },
  component: ViewJob,
  children: [
    {
      meta: {
        authorize: AccessMatrix.JobsTrunk.viewjob_branch,
        display: { key: "servicesystem.pages.page_titles.job_view_job_general" },
        icon: "mdi-home",
        overrides: {
          header: {
            buttons: ['DeleteJobBtn', 'CopyJobBtn', 'CompleteJobBtn', 'ApproveJobBtn', 'CheckListBtn', 'HazardAnalysisBtn', 'ServiceReportBtn'],
          },
        }
      },
      path: "general",
      name: "ViewJobGeneral",
      component: ViewJobGeneral
    },

    {
      meta: {
        authorize: AccessMatrix.JobsTrunk.viewjob_branch,
        display: { key: "servicesystem.pages.page_titles.job_view_job_planning" },
        icon: "mdi-calendar",
        overrides: {
          header: {
            buttons: ['NewAppointmentBtn'],
          },
        }
      },
      path: "planning/:appointmentId?",
      name: "ViewJobPlanning",
      component: ViewJobPlanning
    },
    {
      meta: {
        authorize: AccessMatrix.JobsTrunk.viewjob_branch,
        display: { key: "servicesystem.pages.page_titles.job_view_job_logg" },
        icon: "mdi-timeline-text",
      },
      path: "logg",
      name: "ViewJobLogg",
      component: ViewJobLogg
    },
    {
      meta: {
        authorize: AccessMatrix.JobsTrunk.viewjob_branch,
        display: { key: "servicesystem.common_objects.document.resources" },
        icon: "mdi-folder-open",
        overrides: {
          header: {
            buttons: ['CheckListBtn', 'HazardAnalysisBtn', 'ServiceReportBtn'],
          },
        }
      },
      path: "resources",
      name: "ViewJobResources",
      component: ViewJobResources,
      children: [
        {
          meta: {
            authorize: AccessMatrix.JobsTrunk.viewjob_branch,
            display: 'Service Report',
            icon: "mdi-receipt-text",
            overrides: {
              header: {
                buttons: ['PrintServiceReportBtn', 'AttachServiceReportBtn', 'DownloadServiceReportBtn'],
              },
            },
            resourceOverlay: true,
          },
          name: "GenerateServiceReport",
          path: "servicereport/:templateKey?",
          component: ReportViewer,
        },
        {
          meta: {
            licenseEnabled: LicenseKeys.CheckList,
            authorize: AccessMatrix.JobsTrunk.viewjob_branch,
            display: { key: "servicesystem.common_objects.checklist.checklists" },
            icon: "$checklist",
            overrides: {
              header: {
                buttons: ['PrintCheckListReportBtn', 'AttachCheckListReportBtn', 'DownloadCheckListReportBtn'],
              },
            },
            resourceOverlay: true,
          },
          name: "ViewJobCheckList",
          path: "checklist/:templateKey?",
          component: ViewCheckLists,
        },
      ]
    },
    {
      meta: {
        authorize: AccessMatrix.JobsTrunk.viewjob_branch,
        display: { key: "servicesystem.pages.page_titles.job_view_job_order" },
        icon: "mdi-hammer-wrench",
        overrides: {
          submenutab: SubMenuTab_OrderDependent,
        },
        contextMenu: 'Inherit',
      },
    
      path: "order",
      name: "ViewJobOrder",
      component: ViewJobOrder,
      children: [
        {
          meta: {
            authorize: AccessMatrix.JobsTrunk.viewjob_branch,
            displayName: 'Edit',
            icon: "mdi-hammer-wrench",
          },
          name: "JobEditOrderLine",
          path: "edit/:machineJobId/:lineId?",
          component: OrderDetailForm,
        },
        {
          meta: {
            authorize: AccessMatrix.JobsTrunk.viewjob_branch,
            displayName: 'Add',
            icon: "mdi-hammer-wrench",
          },
          name: "JobAddOrderLine",
          path: "add/:machineJobId/:articleNumber?",
          component: CreateOrderDetailMenu,
        },
      ]
    },
    {
      meta: {
        authorize: AccessMatrix.JobsTrunk.viewjob_branch,
        display: { key: "servicesystem.pages.page_titles.job_view_job_pre_invoice" },
        icon: "mdi-cash-multiple",
        overrides: {
          header: {
            buttons: ['DeleteJobBtn', 'CompleteJobBtn', 'ApproveJobBtn', 'CheckListBtn', 'HazardAnalysisBtn', 'ServiceReportBtn'],
          },
          submenutab: SubMenuTab_OrderDependent,
        }
      },
      path: "invoice",
      name: "ViewJobInvoice",
      component: ViewJobInvoice
    },
  ]
};

export default branch;
